import React from 'react';
import { Modal, ModalBody } from "reactstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const PriorityModal = ({ show, setShow, selectedRow = {}, priority = [], onSubmit }) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    Priority: Yup.number().nullable(),
  });

  return (
    <Modal isOpen={show} centered size="md">
      <ModalBody className="py-3 px-5">
        <Formik
          enableReinitialize
          initialValues={{
            Priority: selectedRow.Priority ?? null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            onSubmit(values);   
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, setFieldValue, values, touched, errors, isValid }) => (
            <Form>
              <div className="mt-2 text-center">
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4 className="d-flex justify-content-start">
                        {t("Select priority")}
                    </h4>

                    <div className="text-start">
                      <Select
                        name="Priority"
                        className={touched.Priority && errors.Priority ? "is-invalid" : ""}
                        styles={{
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "white",
                          }),
                        }}
                        menuPosition="fixed"
                        options={(priority || []).map((item) => ({
                          value: item.ID,
                          label: t(item.Label),
                        }))}
                        
                        // ✅ FIXED VALUE
                        value={
                          priority
                            .map((item) => ({ value: item.ID, label: item.Label }))
                            .find((o) => o.value === values.Priority) || null
                        }

                        // ✅ FIXED onChange
                        onChange={(option) => {
                          setFieldValue("Priority", option?.value || null);
                        }}

                        noOptionsMessage={() => t("NoOptions")}
                      />

                      {touched.Priority && errors.Priority && (
                        <div className="invalid-feedback d-block">
                          {errors.Priority}
                        </div>
                      )}
                    </div>
                </div>
              </div>

              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn w-sm btn-light"
                  onClick={() => setShow(false)}
                >
                  {t("Close")}
                </button>

                <button
                  type="submit"
                  className="btn w-sm btn-danger"
                  disabled={isSubmitting || !isValid}
                >
                  {t("Save")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default PriorityModal;
